var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-content"},[_c('div',[_c('navbar'),_c('modal-register'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),(_vm.currentRouteName != 'landingRegister' && _vm.currentRouteName != 'landingQuickRegister')?_c('btn'):_vm._e(),_c('whatsAppButton'),_c('footerLanding')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }